export default __webpack_public_path__ + "static/media/avatar.f9782eae.svg";